export default __webpack_public_path__ + "static/media/pilz-09.6b771087.png";